<template>
  <div class="classes-list">
    <div class="nav-bar">
      <van-nav-bar title="选择班级" right-text="" fixed left-arrow @click-left="onClickLeft" />
    </div>
    <div>
      <div class="content">
        <van-search v-model="searchVal" placeholder="请输入班级名称" />
        <div class="class-item" v-for="item in classList" :key="item.id">
          <div class="ellipsis1 name">{{item.name}}</div>
          <div class="ellipsis1 classSlogan">
  
          </div>
          <div class="more flex">
            <div>班级人数：{{item.count}}人</div>
            <div class="add-class" @click="addJoinClass(item)">
              加入班级
            </div>
          </div>
        </div>
        <div class="class-item">
          <div class="ellipsis1 name">大同市赛区</div>
          <div class="ellipsis1 classSlogan">
  
          </div>
          <div class="more flex">
            <div>班级人数：27人</div>
            <div class="add-class">
              加入班级
            </div>
          </div>
        </div>
        <div class="class-item">
          <div class="ellipsis1 name">朔州市赛区</div>
          <div class="ellipsis1 classSlogan">
  
          </div>
          <div class="more flex">
            <div>班级人数：6人</div>
            <div class="add-class">
              加入班级
            </div>
          </div>
        </div>
        <div class="class-item">
          <div class="ellipsis1 name">忻州市赛区</div>
          <div class="ellipsis1 classSlogan">
  
          </div>
          <div class="more flex">
            <div>班级人数：11人</div>
            <div class="add-class">
              加入班级
            </div>
          </div>
        </div>
        <div class="class-item">
          <div class="ellipsis1 name">阳泉市赛区</div>
          <div class="ellipsis1 classSlogan">
  
          </div>
          <div class="more flex">
            <div>班级人数：30人</div>
            <div class="add-class">
              加入班级
            </div>
          </div>
        </div>
        <div class="class-item">
          <div class="ellipsis1 name">吕梁市赛区</div>
          <div class="ellipsis1 classSlogan">
  
          </div>
          <div class="more flex">
            <div>班级人数：18人</div>
            <div class="add-class">
              加入班级
            </div>
          </div>
        </div>
        <div class="class-item">
          <div class="ellipsis1 name">晋中市赛区</div>
          <div class="ellipsis1 classSlogan">
  
          </div>
          <div class="more flex">
            <div>班级人数：43人</div>
            <div class="add-class">
              加入班级
            </div>
          </div>
        </div>
        <div class="class-item">
          <div class="ellipsis1 name">长治市赛区</div>
          <div class="ellipsis1 classSlogan">
  
          </div>
          <div class="more flex">
            <div>班级人数：15人</div>
            <div class="add-class">
              加入班级
            </div>
          </div>
        </div>
        <div class="class-item">
          <div class="ellipsis1 name">晋城市赛区</div>
          <div class="ellipsis1 classSlogan">
  
          </div>
          <div class="more flex">
            <div>班级人数：21人</div>
            <div class="add-class">
              加入班级
            </div>
          </div>
        </div>
        <div class="class-item">
          <div class="ellipsis1 name">临汾市赛区</div>
          <div class="ellipsis1 classSlogan">
  
          </div>
          <div class="more flex">
            <div>班级人数：61人</div>
            <div class="add-class">
              加入班级
            </div>
          </div>
        </div>
        <div class="class-item">
          <div class="ellipsis1 name">运城市赛区</div>
          <div class="ellipsis1 classSlogan">
  
          </div>
          <div class="more flex">
            <div>班级人数：6人</div>
            <div class="add-class">
              加入班级
            </div>
          </div>
        </div>
      </div>
    </div>
  
  </div>
</template>
<script>
import Vue from 'vue'
import NavBar from 'vant/lib/nav-bar';
import 'vant/lib/nav-bar/style';
import Tabs from 'vant/lib/tabs';
import 'vant/lib/tabs/style';
import Tab from 'vant/lib/tab';
import 'vant/lib/tab/style';
import Button from 'vant/lib/button';
import 'vant/lib/button/style';
import Search from 'vant/lib/search';
import 'vant/lib/search/style';
import Dialog from 'vant/lib/dialog';
import 'vant/lib/dialog/style';
Vue.use(Search)
Vue.use(NavBar)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(Button)
// Vue.use(Dialog)
import CountTo from 'vue-count-to'
import { getDashboard } from '@/api/exam/examRecord'
import { courseList } from '@/api/exam/course'
import { wexinShare } from '@/utils/weixinSDK'
import { isWeixin } from "@/utils/utils";

const logoUrl = require("@/assets/img/logo.jpg");
export default {
  props: {
    step: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      searchVal: '',
      show: false,
      banner_bg: require("@/assets/img/bg-img/bg2.jpg"),
      activeTab: 0, // 必须为数字，0表示第一个标签[3,4](@ref)
      activeColor: "rgb(59, 112, 255)", // 直接写颜色值，无分号
      bgColor: "rgb(240, 240, 240)",    // 背景色示例（非必须）
      classList: [{
        id: 1,
        name: '太原市赛区',
        count: 6,

      }, {
        id: 2,
        name: '运城市赛区',
        count: 6,

      }]
    }
  },
  components: {
    CountTo,


  },
  created() {

  },
  mounted() {
    document.title = '山西省第三届家庭教育指导技能大赛报名'
  },

  methods: {

    getDashboard() {
      getDashboard().then(resp => {
        this.dashboardInfo = resp.data;
      });
    },
    // 加载课程列表
    getCourseList() {
      courseList(this.courseQuery).then(response => {
        this.courseList = response.rows;
      }).catch(() => {
      })
    },
    handleStartCourse(course) {
      // messageWarn(this, '功能正在开发中！')
      this.$router.push({ name: 'course-details', query: { courseId: course.id } })
    },
    toPage(pageName) {
      this.$router.push({ name: pageName })
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    addJoinClass() {
      Dialog.confirm({
        title: '',
        message: '确定加入该班级？',
      })
        .then(() => {
          this.toPage('communicationgroup')
          // on confirm
        })
        .catch(() => {
          // on cancel
        });
    }


  },

}
</script>

<style lang="scss" scoped>
.classes-list {
  .nav-bar {
    ::v-deep .van-icon {
      color: #000;
      font-size: 18px;
    }
  }

  .content {
    padding-top: 48px;

    .class-item {
      padding: 21px 16px;
      border-bottom: 1px solid #eee;
      font-size: 13px;

      .name {
        font-size: 14px;
      }


      .ellipsis1 {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .classSlogan {
        color: #999;
        font-size: 12px;
        margin-top: 10px;
      }

      .more {
        margin-top: 10px;

        &>div:first-child {
          color: #555;
        }

        .add-class {
          color: #4d83ef;
          border: 1px solid #4d83ef;
          padding: 5px;
          border-radius: 2px;
        }
      }

      .flex {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
      }
    }
  }
}
</style>
